export enum ModelItemType {
  circle = 'circle',
  rectangle = 'rectangle',
  freehand = 'freehand',
  number = 'number',
  svgElement = 'svgElement'
}
interface AnnotationModelItemData {
  position: [number, number];
  color: string;
  strokeWidth: number;
}

export interface CircleData extends AnnotationModelItemData {
  radius: number;
}

export interface SvgData extends AnnotationModelItemData {
  element: string;
  size: [number, number];
}

export interface FreeHandData extends AnnotationModelItemData {
  path: string;
}

export interface NumberData extends AnnotationModelItemData {
  description: string;
  number: number;
}

export interface RectangleData extends AnnotationModelItemData {
  size: [number, number];
}

export interface EllipseData extends AnnotationModelItemData {
  size: [number, number];
}

export interface AnnotationModelItem {
  id: string;
  type: ModelItemType;
  data: CircleData | FreeHandData | NumberData | RectangleData | SvgData;
}

export interface AnnotationModel {
  size: [number, number];
  items: AnnotationModelItem[];
  svg: any;
}
